import { QueryHookOptions } from '@apollo/client';
import { useQuery } from '@ts-gql/apollo';
import { OperationData, OperationVariables, gql } from '@ts-gql/tag';
import React from 'react';

export const GET_JOBS_BY_IDS_QUERY = gql`
  query GetJobsByIds($cloudIds: [String!]!) {
    getJobsByIds(cloudIds: $cloudIds) {
      cloudId
      name
      jobStatusId
      clientId
      WfDeletedOnUTC
    }
  }
` as import('../../__generated__/ts-gql/GetJobsByIds').type;

export type GetJobsByIdsQueryVariables = OperationVariables<
  typeof GET_JOBS_BY_IDS_QUERY
>;
export type GetJobsByIdsQueryResult = OperationData<
  typeof GET_JOBS_BY_IDS_QUERY
>;
export type GetJobsByIdsType = GetJobsByIdsQueryResult['getJobsByIds'];

export type GetJobsByIdsResult = NonNullable<
  ReturnType<typeof processData>
>[number];

// type picked = Pick<
//   Job,
//   'cloudId' | 'name' | 'jobStatusId' | 'clientId' | 'WfDeletedOnUTC'
// >;
// type omitted = Omit<picked, 'WfDeletedOnUTC'>;

// export interface GetJobsByIdsResult extends omitted {
//   WfDeletedOnUTC?: Date | null;
// }

export const useGetJobsByIds = (
  options: QueryHookOptions<GetJobsByIdsQueryResult, GetJobsByIdsQueryVariables>
) => {
  const variables = options.variables as GetJobsByIdsQueryVariables;

  const res = useQuery(GET_JOBS_BY_IDS_QUERY, {
    context: { service: 'core' },
    variables,
    ...options,
  });

  return React.useMemo(() => ({ ...res, data: processData(res.data) }), [res]);
};

export function processData(data: GetJobsByIdsQueryResult | undefined) {
  const rawRows = data?.getJobsByIds;
  const result = rawRows?.map((raw) => ({
    ...raw,
    WfDeletedOnUTC: raw.WfDeletedOnUTC && new Date(raw.WfDeletedOnUTC),
  }));
  return result;
}
